import { CalendarDate, getLocalTimeZone } from "@internationalized/date";
import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useMindlerApi } from "../../api/apiv2";
import { formatCanceledSlotsTableData } from "./cancelledSlots";

export const useCancelledBookings = ({
  psychologistUserId,
  dateRangeValue,
}: {
  psychologistUserId: number;
  dateRangeValue: {
    start: CalendarDate;
    end: CalendarDate;
  } | null;
}) => {
  const { t } = useTranslation();
  const api = useMindlerApi();
  const fromDate =
    dateRangeValue &&
    dateRangeValue.start &&
    dateRangeValue?.start?.toDate(getLocalTimeZone());
  const toDate =
    dateRangeValue &&
    dateRangeValue.end &&
    dateRangeValue?.end?.add({ days: 1 }).toDate(getLocalTimeZone());

  const validDateRangeValue = () => {
    if (!dateRangeValue || !fromDate || !toDate || fromDate >= toDate) {
      return false;
    }

    return true;
  };

  // @TODO: As a result of each of this functions we filter out only canceled slots
  // which I think should be done in the backend since we do not need other slots.
  // these queries should take options.
  const { data: psychologistSlots, isLoading: psychologistsSlotsLoading } =
    useQuery(
      api.slots.getPsychologistSlotsInTimeFrame.queryOptions(
        {
          psychologistUserId,
          fromDate: fromDate as Date,
          toDate: toDate as Date,
        },
        {
          enabled: validDateRangeValue() && psychologistUserId !== -1,
        },
      ),
    );

  const formattedPsychologistSlots = useMemo(
    () => formatCanceledSlotsTableData(psychologistSlots, t),
    [psychologistSlots, t],
  );

  const { data: allSlots, isLoading: allSlotsLoading } = useQuery(
    api.slots.getAllSlotsInTimeFrame.queryOptions(
      {
        fromDate: fromDate as Date,
        toDate: toDate as Date,
      },
      {
        enabled: validDateRangeValue() && psychologistUserId === -1,
      },
    ),
  );

  const formattedAllSlots = useMemo(
    () => formatCanceledSlotsTableData(allSlots, t),
    [allSlots, t],
  );

  return psychologistUserId === -1
    ? {
        bookings: formattedAllSlots,
        isLoading: allSlotsLoading,
      }
    : {
        bookings: formattedPsychologistSlots,
        isLoading: psychologistsSlotsLoading,
      };
};
